// import { Outlet } from "react-router-dom";

// const AuthLayout = () => {
//   return (
//     <div className={styles["full-screen"]}>
//       <Outlet />
//     </div>
//   );
// };

// export default AuthLayout;


// src/components/AuthLayout.tsx

// import React from 'react';
// import SignIn from './auth/SignIn/index';
// import SignUp from './auth/SignUp/index';
// import styles from "./styles.module.css";

// const AuthLayout: React.FC = () => {
//     return (
//         <div className={styles['auth-container']}>
//             <div className={styles["auth-column"]}>
//                 <SignIn />
//             </div>
//             <div className={styles["auth-column"]}>
//                 <SignUp />
//             </div>
//         </div>
//     );
// };

// export default AuthLayout;

import { useContext } from "react";
import { GlobalContext } from "../lib/context";
import { Outlet, Navigate } from "react-router-dom";
import Loading from "./Loading";


const AuthLayout = () => {
    const { loading, auth, profile } = useContext(GlobalContext);

    // if (loading) {
    //     return <Loading />;
    // }

    // return auth ? (
    //     profile.user_role === "Admin" ? <Navigate to="/cxspsa/dashboard" /> : <Navigate to="/cxspsa" />
    // ) : (
    //     <div className="container">
    //         <Outlet />
    //     </div>
    // );

    if (loading) {
        return <Loading />;
    }
    
    if (auth) {
        if (profile.user_role === "Admin") {
            return <Navigate to="/cxspsa/dashboard" />;
        } else if (profile.user_role === "Normal") {
            // window.location.href = "https://ylot.com/psa";
            window.location.href = `${process.env.REACT_APP_PSA_URL || ""}/`;

            return null; // Return null to stop rendering further
        } else {
            return <Navigate to="/cxspsa" />;
        }
    }
    
    return (
        <div className="container">
            <Outlet />
        </div>
    );
    
};

export default AuthLayout;


